import type { FunctionComponent } from 'react';
import BuildList from '../BuildList';
import useBuildList from '../ProjectBuildsPage/useBuildList';
import BuildCard from './BuildCard';
import { DocsLink, IconText, RouterLink, icons } from '../../generic';
import { nuc } from '../../../utils';
import type { RevisionStatus } from '../dependencies/utils';
import type { ProjectDashboardRevision } from '../projectDashboardTypes';

type Props = {
  defaultBranch: string;
  isCLIBuild: boolean;
  userCanEditProject: boolean;
  isSubmittingBuild: boolean;
  revisionLocator: string;
  revisionMessage: string;
  reference: string;
  revisionId: string;
  projectId: string;
  status: Omit<RevisionStatus, 'failing' | 'analyzed'>;
  onProjectChange?: () => void;
  revision: ProjectDashboardRevision;
};

const ProjectSummaryBuildInfo: FunctionComponent<Props> = ({
  defaultBranch,
  isCLIBuild,
  revisionLocator,
  revisionMessage,
  isSubmittingBuild,
  userCanEditProject,
  reference,
  revisionId,
  status,
  projectId,
  onProjectChange,
  revision,
}) => {
  const {
    builds,
  } = useBuildList({
    mode: 'REVISION',
    locator: `${projectId}$${revisionId}`,
  });

  return (
    <div className="row">
      <div className="col-md-8 col-md-offset-2">
        <div className="animated fadeInUp fast">
          <BuildCard
            status={status}
            reference={reference}
            revisionId={revisionId}
            isCLIBuild={!!isCLIBuild}
            defaultBranch={defaultBranch}
            revisionLocator={revisionLocator}
            revisionMessage={revisionMessage}
            isSubmittingBuild={isSubmittingBuild}
            userCanEditProject={userCanEditProject}
          />
          {!isSubmittingBuild && (
            <BuildList
              builds={builds}
              onLatestComplete={onProjectChange}
              currentRevision={revision}
            >
              <div>
                {isCLIBuild && (
                  <div className="card">
                    <h4>Provided Builds</h4>
                    <p>
                      This project is configured with <b>Provided Builds</b>. FOSSA has not received build results for
                      this version yet. Check the status of your build and the FOSSA plugin.
                    </p>
                    &nbsp;
                    <RouterLink className="btn" to={`/projects/${nuc(projectId)}/settings/builds`}>
                      <IconText
                        icon={icons.customize}
                        text="Configure Provided Builds"
                      />
                    </RouterLink>
                    &nbsp;&nbsp;&nbsp;
                    <DocsLink
                      to="provided-builds"
                      className="btn"
                    >
                      <IconText
                        icon={icons.download}
                        text="Download the Plugin"
                      />
                    </DocsLink>
                  </div>
                )}
              </div>
            </BuildList>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectSummaryBuildInfo;
